import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { type ResponseHeader, ResponseHeaderSchema } from '../responseHeader'
import {
  type GetProfileResponsePayload,
  GetProfileResponsePayloadSchema,
} from './getProfileResponsePayload'

export type GetProfileResponse = {
  header: ResponseHeader
  payload?: GetProfileResponsePayload
}

export const GetProfileResponseSchema: CborSchema<GetProfileResponse> =
  defineCborSchema<GetProfileResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({
      key: 1,
      required: false,
      type: GetProfileResponsePayloadSchema,
    }),
  })
